SectionProfile.Event.Create = Class(
	/**
	 * @lends {SectionProfile.Event.Create#}
	 */
	{
		__NAME: 'SectionProfile.Event.Create',
		bodyClass: 'small-nav grey hide-tablet-footer',
		name: 'team-create',
		TOP_BAR: true,

		_draw: function () {
			this.node = mkE({
				tag: 'div',
				id: 'profile-team-create',
				els: [
					this.wizard = new SectionProfile.Event.Create.Wizard(this.apiCall)
				]
			}).append(this._content);
			mkE({
				tag: 'div',
				className: 'container purchase-disclaimer',
				els: [
					{
						tag: 'div',
						className: 'disclaimer',
						els: [
							D.Lang.get('profile.team.purchase.receiver'),
							{
								tag: 'br'
							},
							D.Lang.get('profile.team.purchase.address')
						]
					},
					{
						tag: 'img',
						src: '/assets/images/payments.svg'
					}
				]
			}).append(this._mainNode);
		},

		_ready: function () {
			this._drawSidebar({purchase: true});
			this.wizard.url = this.url;
			this.wizard.event = this.event;
			this.wizard.draw();
			this.track();
		},

		track() {
			D.Analytics.klaviyo("Added to Cart", {
				"$value": this.event.ticket.affiliatePrice / 100,
				"AddedItemProductID": this.event.id,
				"AddedItemProductName": this.event.title,
				"AddedItemDescription": this.event.description,
				"AddedItemQuantity": 1,
				"AddedItemPrice": this.event.ticket.affiliatePrice / 100,
				"AddedItemURL": D.URL + D.url('/event/' + this.event.seoTitle).substring(1),
				"Items": [{
					"ExperienceID": this.event.id,
					"ExperienceName": this.event.title,
					"Description": this.event.description,
					"Quantity": 1,
					"ItemPrice": this.event.ticket.affiliatePrice / 100,
					"RowTotal": this.event.ticket.affiliatePrice / 100,
					"URL": D.URL + D.url('/event/' + this.event.seoTitle).substring(1)
				}]
			});
			D.Analytics.fbq('AddToCart', {
				content_type: 'product',
				contents: [{
					id: this.event.id,
					quantity: 1
				}],
				currency: 'EUR',
				value: this.event.ticket.affiliatePrice / 100
			});
		}
	},
	SectionProfile.EventBase
);

SectionProfile.Event.Create.Wizard = Class(
	/**
	 * @lends {SectionProfile.Event.Create.Wizard#}
	 */
	{
		__NAME: 'SectionProfile.Event.Create.Wizard',

		TYPE_PRIVATE: 'private',
		TYPE_COMPANY: 'company',

		/** @type {DR.users.struct.User} */
		user: null,
		/** @type {DR.services.struct.PreparePurchaseTicketRe} */
		data: null,
		/** @type {DR.events.struct.Event} */
		event: null,
		/** @type {Url} */
		url: null,

		_isSimplePayment: true,
		_steps: [],
		_stepsMap: {},
		_fields: {
			private: {},
			company: {}
		},
		_price: 0,
		_actualPrice: 0,
		_discountedPrice: 0,
		_discount: {
			type: 'static',
			amount: 0,
			validUntil: null
		},
		_useAffiliateDiscount: false,
		_affiliateDiscountData: {
			type: 'static',
			amount: 0
		},

		/**
		 * @param {DR.ApiCall} apiCall
		 * */
		__construct: function (apiCall) {
			this.node = mkE({
				tag: 'div',
				id: 'purchase-wizard'
			});

			this._mGetMyData = new DR.users.GetMyData();
			this._mGetMyData.onLoad = this._mGetMyDataRe;
			this._mGetMyData.select = [
				new DR.users.select.MyData().user(),
				new DR.users.select.User().id().name().surname().email()
			];
			apiCall.addMethod(this._mGetMyData);

			this._mPreparePurchase = new DR.services.PreparePurchaseTicket();
			this._mPreparePurchase.onLoad = this._mPreparePurchaseRe;
			apiCall.addMethod(this._mPreparePurchase);

			this._mPurchase = new DR.services.PurchaseTicket();
			this._mPurchase.onLoad = this._mPurchaseRe;
			this._mPurchase.onError = this._mPurchaseErr;

			this._mCheckDiscount = new DR.services.CheckDiscount();
			this._mCheckDiscount.onLoad = this._mCheckDiscountRe;
			this._mCheckDiscount.onError = this._mCheckDiscountErr;

			this._mCheckVAT = new DR.services.CheckVAT();
			this._mCheckVAT.onLoad = this._mCheckVATRe;
			this._mCheckVAT.onError = this._mCheckVATErr;
		},

		draw: function () {
			if (this._mPreparePurchase.error) {
				switch (this._mPreparePurchase.error) {
					case 'has team':
						const get = new Get('/profile/event/' + this.event.seoTitle);
						if (this.url.get.is('pmt-success')) {
							get.add('pmt-success');
						}
						Section.navigate(D.url(get.toUrl()));
						return;
					case 'event not active':
						Section.navigate(D.url('/profile'));
						return;
					default:
						T.error(D.Lang.get('profile.team.purchase.errors.general')).prepend(this.node);
						return;
				}
			}

			this._initSteps();

			this._wizard = new T.Wizard({
				getSteps: this._getSteps,
				returnUrl: D.url('/profile'),
				onStepChange: function () {
					$(window).scrollTop(0);
				}
			}).append(this.node);

			if (this.url.get.is('pmt-cancelled') || this.url.get.is('pmt-error')) {
				T.error(D.Lang.get('profile.team.purchase.errors.cancelled')).prepend(this._purchaseForm);
				this._wizard.setStep(this._paymentInfoStep);
			} else if (this.url.get.is('pmt-expired')) {
				T.error(D.Lang.get('profile.team.purchase.errors.expired')).prepend(this._purchaseForm);
				this._wizard.setStep(this._paymentInfoStep);
			}
		},

		_getSteps: function () {
			return this._steps;
		},

		_initSteps: function () {
			this._addStepSimplePayment();

			this._price = this.event.ticket.affiliatePrice;
			this._priceNoVAT = this.event.ticket.affiliatePriceNoVAT;
			this._hasVAT = true;
			this._updatePrice();
		},

		_addStepSimplePayment: function () {
			let title = D.Lang.get('profile.team.purchase.simple.title');
			let description = D.Lang.get('profile.team.purchase.simple.description');
			if (this.event.settings.ticketPerPerson) {
				title = D.Lang.get('profile.team.purchase.simpleTeam.title');
				description = D.Lang.get('profile.team.purchase.simpleTeam.description3');
			} else if (this.event.minPlayers > 1) {
				title = D.Lang.get('profile.team.purchase.simpleTeam.title');
				description = D.Lang.get('profile.team.purchase.simpleTeam.description2');
			} else if (this.event.maxPlayers > 1) {
				title = D.Lang.get('profile.team.purchase.simpleTeam.title');
				description = D.Lang.get('profile.team.purchase.simpleTeam.description');
			}
			description = description.replace('%TITLE%', this.event.title).replace('%MAX_PLAYERS%', this.event.maxPlayers).replace('%MIN_PLAYERS%', this.event.minPlayers);
			this._stepsMap['review'] = new T.Wizard.Step({
				caption: '',
				getContent: mkE({
					tag: 'div',
					className: 'team-create-step team-create-payment',
					els: [
						this._errorHolder = mkE({
							tag: 'div'
						}),
						{
							tag: 'h2',
							text: title
						},
						{
							tag: 'p',
							text: description
						},
						this._getPurchaseForm()
					]
				}),
				canContinue: true,
				continueAction: this._purchase,
				continueText: D.Lang.get('profile.team.purchase.buy'),
				canGoBack: false,
				bottomContent: this._bottomPriceNode,
				onActivate: this._onPurchaseActivate
			});
			const step = this._steps.push(this._stepsMap['review']) - 1;
			this._teamStep = step;
			this._reviewStep = step;
			this._paymentInfoStep = step;
		},

		_getPurchaseForm: function () {
			this._selectedTab = this.data.paymentInfo.type || this.TYPE_PRIVATE;
			this._tabHeaders = {};
			this._tabs = {};
			this._fields = {
				private: {},
				company: {}
			};

			let countries = [];
			for (let cc in D.countries[D.LANG]) {
				if (!D.countries[D.LANG].hasOwnProperty(cc)) {
					continue;
				}
				countries.push({
					value: cc,
					caption: D.countries[D.LANG][cc]
				});
			}
			this._discountCode = '';
			this._purchaseForm = mkE({
				tag: 'div',
				className: 'team-create-purchase-form',
				els: [
					{
						tag: 'div',
						className: 'purchase-tabs',
						els: [
							{
								tag: 'div',
								className: 'purchase-tabs-header',
								els: [
									this._tabHeaders[this.TYPE_COMPANY] = new T.Form.CheckBox({
										caption: mkE({
											tag: 'span',
											className: 'purchase-type-checkbox',
											text: D.Lang.get('profile.team.purchase.tabs.company')
										}),
										checked: this.data.paymentInfo.type && this.data.paymentInfo.type === this.TYPE_COMPANY,
										onChange: D.closure(this, function () {
											if (this._tabHeaders[this.TYPE_COMPANY].value()) {
												this._selectedTab = this.TYPE_COMPANY;
												addClassName(this._tabs[this.TYPE_COMPANY], 'active');
												removeClassName(this._tabs[this.TYPE_PRIVATE], 'active');
											} else {
												this._selectedTab = this.TYPE_PRIVATE;
												addClassName(this._tabs[this.TYPE_PRIVATE], 'active');
												removeClassName(this._tabs[this.TYPE_COMPANY], 'active');
											}
											this._checkVAT();
										})
									})
								]
							},
							{
								tag: 'div',
								className: 'purchase-tabs-content',
								els: [
									this._tabs[this.TYPE_PRIVATE] = mkE({
										tag: 'div',
										className: 'purchase-tab purchase-tab-private' + (this._selectedTab === this.TYPE_PRIVATE ? ' active' : ''),
										els: [
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													this.event.settings.hasStickers ? {
														tag: 'div',
														className: 'left',
														els: [
															this._fields.private.phone = new T.Form.Phone({
																caption: D.Lang.get('profile.team.purchase.company.phone'),
																border: true,
																code: Number(this.data.paymentInfo.phoneCode || 371),
																value: this.data.paymentInfo.phone || ''
															})
														]
													} : ''
												]
											}
										]
									}),
									this._tabs[this.TYPE_COMPANY] = mkE({
										tag: 'div',
										className: 'purchase-tab purchase-tab-company' + (this._selectedTab === this.TYPE_COMPANY ? ' active' : ''),
										els: [
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													{
														tag: 'div',
														className: 'left',
														els: [
															this._fields.company.name = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.name'),
																border: true,
																value: this.data.paymentInfo.name || ''
															})
														]
													},
													{
														tag: 'div',
														className: 'right',
														els: [
															this._fields.company.phone = new T.Form.Phone({
																caption: D.Lang.get('profile.team.purchase.company.phone'),
																border: true,
																code: Number(this.data.paymentInfo.phoneCode || 371),
																value: this.data.paymentInfo.phone || ''
															})
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													{
														tag: 'div',
														className: 'left',
														els: [
															this._fields.company.registrationNumber = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.reg'),
																border: true,
																value: this.data.paymentInfo.registrationNumber || ''
															})
														]
													},
													{
														tag: 'div',
														className: 'right',
														els: [
															this._fields.company.vatNumber = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.vat'),
																border: true,
																value: this.data.paymentInfo.vatNumber || '',
																onChange: this._checkVAT
															})
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													{
														tag: 'div',
														className: 'left',
														els: [
															this._fields.company.country = new T.Form.Select({
																caption: D.Lang.get('profile.team.purchase.company.country'),
																border: true,
																options: countries,
																value: this.data.paymentInfo.country || 'LV',
																onChange: this._checkVAT
															})
														]
													},
													{
														tag: 'div',
														className: 'right',
														els: [
															this._fields.company.city = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.city'),
																border: true,
																value: this.data.paymentInfo.city || ''
															})
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'form-row',
												els: [
													this._fields.company.address = new T.Form.Input({
														caption: D.Lang.get('profile.team.purchase.company.address'),
														border: true,
														value: this.data.paymentInfo.address || ''
													})
												]
											}
										]
									})
								]
							}
						]
					},
					this.event.settings.ticketPerPerson ? this._getPersonSelector() : this._getTeamCountToggle(),
					this._teamCountContainer = mkE({
						tag: 'div',
						className: 'team-count-container',
						els: [
							{
								tag: 'div',
								className: 'label',
								els: [
									{
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('profile.team.purchase.teamCount')
									}
								]
							},
							this._teamCount = new T.Form.Count({
								min: 1,
								max: 20,
								value: 1,
								onChange: this._onTeamCountChange
							})
						]
					}),
					{
						tag: 'div',
						className: 'team-gift',
						els: [
							{
								tag: 'a',
								href: D.url('/gift-card/event/' + this.event.seoTitle),
								text: D.Lang.get('profile.team.purchase.gift')
							}
						]
					},
					{
						tag: 'div',
						className: 'purchase-form-footer',
						els: [
							this._affiliateDiscount(),
							{
								tag: 'div',
								className: 'purchase-row',
								els: [
									{
										tag: 'div',
										className: 'left',
										els: [
											{
												tag: 'div',
												className: 'total-amount',
												text: D.Lang.get('profile.team.purchase.totalAmount')
											}
										]
									},
									{
										tag: 'div',
										className: 'right',
										els: [
											{
												tag: 'h3',
												els: [
													this._priceText = mkE({
														tag: 'span',
														text: '€' + (this.event.ticket.affiliatePrice / 100).toFixed(2)
													})
												]
											}
										]
									}
								]
							},
							this._discountContainer = mkE({
								tag: 'div',
								className: 'discount-code',
								els: [
									{
										tag: 'div',
										className: 'discount-code-toggle',
										els: [
											{
												tag: 'a',
												onclick: this._toggleDiscount,
												text: D.Lang.get('profile.team.purchase.discount.title')
											}
										]
									},
									this._discountNode = mkE({
										tag: 'div',
										className: 'discount-code-input',
										els: [
											this._discountInput = new T.Form.InputEdit({
												onSave: this._checkDiscount,
												canEdit: true,
												saveCaption: D.Lang.get('profile.team.purchase.discount.save')
											})
										]
									}),
									this._discountRemainder = mkE({
										tag: 'div',
										className: 'discount-code-remainder',
										style: {
											display: 'none'
										},
										els: [
											{
												tag: 'div',
												className: 'd-lg-flex',
												els: [
													{
														tag: 'div',
														els: [
															{
																tag: 'span',
																text: D.Lang.get('profile.team.purchase.discount.remainder')
															},
															this._discountRemainderValue = mkE({
																tag: 'span',
																className: 'numeric'
															})
														]
													},
													{
														tag: 'div',
														els: [
															{
																tag: 'span',
																text: D.Lang.get('profile.team.purchase.discount.valid_untill')
															},
															this._discountRemainderValid = mkE({
																tag: 'span',
																className: 'numeric'
															})
														]
													}
												]
											}
										]
									})
								]
							})
						]
					}
				]
			});
			return this._purchaseForm;
		},

		_affiliateDiscount() {
			if (!(this.event.ticket.hasFirstAffiliateDiscount || this.event.ticket.hasAffiliateDiscount)) {
				return false;
			}
			this._affiliateDiscountData = this.event.ticket.affiliateDiscount;
			let type = 'affiliate'
			if (this.event.ticket.hasFirstAffiliateDiscount) {
				this._affiliateDiscountData = this.event.ticket.firstAffiliateDiscount;
				type = 'first-affiliate'
			}
			this._useAffiliateDiscount = true;
			return this._affiliateContainer = mkE({
				tag: 'div',
				className: 'purchase-row purchase-row-affiliate-discount',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							this._useAffiliateDiscountCheck = new T.Form.CheckBox({
								caption: mkE({
									tag: 'span',
									className: 'affiliate-discount-checkbox',
									text: D.Lang.get('profile.team.purchase.affiliate-discount.' + type)
								}),
								onChange: D.closure(this, function() {
									this._useAffiliateDiscount = !!this._useAffiliateDiscountCheck.value();
									this._updatePrice();
								}),
								checked: this._useAffiliateDiscount
							})
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							{
								tag: 'div',
								className: 'affiliate-discount-amount',
								text: '-' + this._affiliateDiscountData.amount + '%'
							}
						]
					}
				]
			});
		},

		_getPersonSelector() {
			let node = mkE({
				tag: 'div',
				className: 'team-ticket-counts'
			});

			mkE({
				tag: 'div',
				className: 'team-users-count',
				els: [
					{
						tag: 'div',
						className: 'label',
						els: [
							{
								tag: 'div',
								className: 'caption',
								els: [
									D.Lang.get('profile.team.purchase.teamUserCount'),
									{
										tag: 'span',
										text: D.Lang.get('profile.team.purchase.teamUserCount2').replace('%MIN_PLAYERS%', this.event.minPlayers).replace('%MAX_PLAYERS%', this.event.maxPlayers)
									}
								]
							},
							{
								tag: 'div',
								className: 'team-count-toggle',
								els: [
									{
										tag: 'a',
										onclick: this._toggleTeamCount,
										text: D.Lang.get('profile.team.purchase.teamCountToggle')
									}
								]
							}
						]
					},
					this._teamUsersCount = new T.Form.Count({
						min: this.event.minPlayers,
						max: this.event.maxPlayers,
						value: 1,
						onChange: this._onTeamUsersChange
					})
				]
			}).append(node);

			return node;
		},

		_onTeamUsersChange() {
			this._updatePrice();
		},

		_getTeamCountToggle() {
			return mkE({
				tag: 'div',
				className: 'team-count-toggle-single',
				els: [
					{
						tag: 'a',
						onclick: this._toggleTeamCount,
						text: D.Lang.get('profile.team.purchase.teamCountToggle')
					}
				]
			});
		},

		_toggleTeamCount() {
			if (this._teamCountVisible) {
				this._teamCountVisible = false;
				this._tempTeamCount = this._teamCount.value();
				this._teamCount.value(1);
				removeClassName(this._teamCountContainer, 'active');
			} else {
				this._teamCountVisible = true;
				if (this._tempTeamCount) {
					this._teamCount.value(this._tempTeamCount);
					delete this._tempTeamCount;
				}
				addClassName(this._teamCountContainer, 'active');
			}
			this._onTeamCountChange();
		},

		_onTeamCountChange() {
			if (this._discount && this._teamCount.value() > 1) {
				this._tempDiscount = this._discount;
				this._tempDiscountCode = this._discountCode;
				this._discount = null;
				this._discountCode = null;
				this._useAffiliateDiscountCheck?.disabled(false);
				this._discountContainer.style.display = 'none';
				if (this._affiliateContainer) {
					this._useAffiliateDiscount = false;
					this._affiliateContainer.style.display = 'none';
				}
			} else if (!this._discount && this._tempDiscount && this._teamCount.value() === 1) {
				this._discount = this._tempDiscount;
				this._discountCode = this._tempDiscountCode;
				this._useAffiliateDiscountCheck?.disabled(true);
				delete this._tempDiscount;
				delete this._tempDiscountCode;
				this._discountContainer.style.display = '';
				if (this._affiliateContainer) {
					this._useAffiliateDiscount = this._useAffiliateDiscountCheck.value();
					this._affiliateContainer.style.display = '';
				}
			}
			this._updatePrice();
		},

		_toggleDiscount: function () {
			if (this._isDiscountOpen) {
				this._discountNode.style.display = '';
				this._isDiscountOpen = false;
			} else {
				this._discountNode.style.display = 'block';
				this._isDiscountOpen = true;
			}
		},

		_checkDiscount: function (value, saveCb, errorCb) {
			if (value) {
				if (this._mCheckDiscount.processing) {
					return;
				}
				this._mCheckDiscount.onLoad = D.closure(this, this._mCheckDiscountRe, saveCb);
				this._mCheckDiscount.onError = D.closure(this, this._mCheckDiscountErr, errorCb);
				this._mCheckDiscount.code = value;
				this._mCheckDiscount.call({eventId: this.event.id});
			} else {
				saveCb('');
				this._discount = null;
				this._discountCode = null;
				this._useAffiliateDiscountCheck?.disabled(false);
				this._updatePrice();
			}
		},

		_onPurchaseActivate: function () {
			if (!this.data.discountCode) {
				return;
			}
			if (!this._isDiscountOpen) {
				this._toggleDiscount();
			}
			this._checkDiscount(this.data.discountCode, this._discountInput._onSave, this._discountInput._onError);
		},

		_checkVAT: function() {
			this._stepsMap['review'].setCanContinue(false);
			this._mCheckVAT.type = this._selectedTab;
			this._mCheckVAT.country = this._fields.company.country.value();
			this._mCheckVAT.vatNumber = this._fields.company.vatNumber.value() || null;
			this._mCheckVAT.call({eventId: this.event.id});
		},

		_mCheckVATRe: function() {
			this._hasVAT = this._mCheckVAT.re.hasVAT;
			this._updatePrice();
			this._stepsMap['review'].setCanContinue(true);
		},

		_mCheckVATErr: function() {
			this._hasVAT = true;
			this._updatePrice();
			this._stepsMap['review'].setCanContinue(true);
		},

		_updatePrice: function () {
			let actualPrice = this._price;
			if (!this._hasVAT) {
				actualPrice = this._priceNoVAT;
			}
			let count = 1;
			if (this._teamUsersCount) {
				count = this._teamUsersCount.value();
			}
			count *= this._teamCount.value();
			actualPrice *= count;
			let discountedPrice = actualPrice;
			let hasValidDiscount = this._discountCode && this._discount && this._discount.type;
			let hasAffiliateDiscount = this._useAffiliateDiscount && this._affiliateDiscountData && this._affiliateDiscountData.type;
			let remainder = 0;
			if (hasValidDiscount || hasAffiliateDiscount) {
				let discount = this._discount;
				if (hasAffiliateDiscount) {
					discount = this._affiliateDiscountData;
				}
				switch (discount.type) {
					case 'static':
						discountedPrice -= discount.amount;
						remainder = Math.abs(Math.min(0, actualPrice - discount.amount));
						break;
					case 'percent':
						let discountAmount = actualPrice * (discount.amount / 100);
						discountedPrice -= discountAmount;
						discountedPrice = Math.round(discountedPrice);
						break;
				}
			}
			discountedPrice = Math.max(0, discountedPrice);
			if (!discountedPrice) {
				this._steps[this._reviewStep].setContinueText(D.Lang.get('profile.team.purchase.getTicket'));
			} else if (this._teamCount.value() > 1) {
				this._steps[this._reviewStep].setContinueText(D.Lang.get('gift-card.purchase'));
			} else {
				this._steps[this._reviewStep].setContinueText(D.Lang.get('profile.team.purchase.buy'));
			}
			if (this._discount?.validUntil) {
				this._discountRemainder.style.display = '';
				setNodeText(this._discountRemainderValue, '€' + (remainder / 100).toFixed(2));
				setNodeText(this._discountRemainderValid, new D.Date(this._discount.validUntil).format('d.m.Y'));
			} else {
				this._discountRemainder.style.display = 'none';
			}
			clearNode(this._priceText);
			if (actualPrice !== discountedPrice) {
				let els = [
					{
						tag: 'span',
						className: 'grey-strike-text',
						text: '€' + (actualPrice / 100).toFixed(2)
					},
					'€' + (discountedPrice / 100).toFixed(2)
				];
				mkE.appendTypeElement(this._priceText, els);
			} else {
				setNodeText(this._priceText, '€' + (discountedPrice / 100).toFixed(2));
			}
			this._actualPrice = actualPrice;
			this._discountedPrice = discountedPrice;
		},

		_readPaymentInfo: function () {
			const paymentInfo = new DR.services.struct.PaymentInfo();
			if (this._selectedTab === this.TYPE_COMPANY) {
				paymentInfo.type = DR.services.struct.PaymentInfo.TYPE_COMPANY;
				paymentInfo.address = this._fields.company.address.value();
				paymentInfo.city = this._fields.company.city.value();
				paymentInfo.country = this._fields.company.country.value();
				paymentInfo.vatNumber = this._fields.company.vatNumber.value();
				paymentInfo.registrationNumber = this._fields.company.registrationNumber.value();
				paymentInfo.name = this._fields.company.name.value();
				let phone = this._fields.company.phone.value();
				paymentInfo.phone = phone.value;
				paymentInfo.phoneCode = phone.code;
			} else {
				paymentInfo.type = DR.services.struct.PaymentInfo.TYPE_PRIVATE;
				if( this._fields.private.phone ) {
					let phone = this._fields.private.phone.value();
					paymentInfo.phone = phone.value;
					paymentInfo.phoneCode = phone.code;
				}
			}
			return paymentInfo;
		},

		_validatePaymentInfo: function () {
			let isValid = true;
			let paymentInfoErrors = {};
			const fields = this._fields[this._selectedTab];

			if (!fields) {
				return false;
			}

			for (let field in fields) {
				if (fields.hasOwnProperty(field)) {
					if (field === 'vatNumber') {
						continue;
					}
					if (!fields[field].value()) {
						paymentInfoErrors[field] = 'empty';
						isValid = false;
					}
				}
			}

			this._inputErrors({
				inviteEmails: null,
				discountCode: null,
				teamTitle: null,
				paymentInfo: {
					type: this._selectedTab
				},
				re: {
					errors: {
						paymentInfo: paymentInfoErrors
					}
				}
			}, this._selectedTab);

			return isValid;
		},

		_purchase: function () {
			if (this._mPurchase.processing) {
				return;
			}

			if (!this._validatePaymentInfo()) {
				this._wizard.setStep(this._paymentInfoStep);
				return;
			}

			this._mPurchase.playerCount = this._teamUsersCount ? this._teamUsersCount.value() : null;
			this._mPurchase.teamCount = this._teamCount ? this._teamCount.value() : null;

			this._mPurchase.teamTitle = null;
			this._mPurchase.inviteEmails = null;

			this._mPurchase.paymentInfo = this._readPaymentInfo();
			this._mPurchase.discountCode = this._discountCode;
			this._mPurchase.paymentMethod = DR.services.PurchaseTicket.PAYMENTMETHOD_BRAINTREE;

			if (this._useAffiliateDiscount) {
				if (this.event.ticket.hasFirstAffiliateDiscount) {
					this._mPurchase.useFirstAffiliateDiscount = true;
				} else if (this.event.ticket.hasAffiliateDiscount) {
					this._mPurchase.useAffiliateDiscount = true;
				}
			}

			D.loadingOverlay(this.node, {delay: true});
			this._mPurchase.call({eventId: this.event.id});
			clearNode(this._errorHolder);
		},

		_mGetMyDataRe: function () {
			this.user = this._mGetMyData.re.user;
		},

		_mPreparePurchaseRe: function () {
			if (!this.user) {
				T.error(D.Lang.get('profile.team.purchase.errors.general')).prepend(this.node);
				return;
			}
			this.data = this._mPreparePurchase.re;

			this.captain = this.user.name + ' ' + this.user.surname;
		},

		_mPurchaseRe: function () {
			const re = this._mPurchase.re;
			this._inputErrors(this._mPurchase);

			if (!re.ok) {
				D.removeLoadingOverlay(this.node);
				if (re.errors.teamTitle || re.errors.inviteEmails) {
					this._wizard.setStep(this._teamStep);
					return;
				}
				if (!re.errors.paymentInfo.ok) {
					this._wizard.setStep(this._paymentInfoStep);
					return;
				}
				this._wizard.setStep(this._paymentInfoStep);
				this._wizard.setError(D.Lang.get('profile.team.purchase.errors.general'));
			} else {
				if (re.url) {
					window.location.href = re.url;
				} else if (re.paymentMethod === DR.services.PurchaseTicket.PAYMENTMETHOD_BRAINTREE) {
					this._paymentId = re.paymentId;
					D.onBraintree(this._onBraintree);
				}
			}
		},

		_mPurchaseErr: function () {
			D.removeLoadingOverlay(this.node);
			let error = '';
			switch (this._mPurchase.error) {
				case 'auth':
					D.reload();
					break;
				case 'no event access':
					error = 'no_event_access';
					break;
				case 'already purchased':
					error = 'already_purchased';
					break;
				case 'cannot purchase':
					error = 'cannot_purchase';
					break;
				case 'invalid discount code':
					error = 'invalid_discount_code';
					break;
				case 500:
				default:
					error = 'general';
			}
			this._wizard.setError(D.Lang.get('profile.team.purchase.errors.' + error));
		},

		_mCheckDiscountRe: function (cb) {
			cb(this._mCheckDiscount.code);
			this._discountCode = this._mCheckDiscount.code;
			this._useAffiliateDiscountCheck?.disabled(true);
			this._useAffiliateDiscountCheck?.value(false);
			this._useAffiliateDiscount = false;
			this._discount = this._mCheckDiscount.re;
			this._updatePrice();
		},

		_mCheckDiscountErr: function (cb) {
			this._discountCode = null;
			this._useAffiliateDiscountCheck?.disabled(false);
			this._discount = {
				type: 'static',
				amount: 0,
				validUntil: null
			};
			this._updatePrice();
			switch (this._mCheckDiscount.error) {
				case 'invalid code':
					cb(D.Lang.get('profile.team.purchase.discount.error'));
					break;
				default:
					cb(D.Lang.get('profile.team.purchase.errors.general'));
			}
		},

		_inputErrors: function (m) {
			const re = m.re;
			const errors = re.errors;

			if (m.teamTitle !== null) {
				let error = errors && errors.teamTitle ? errors.teamTitle : null;
				this._titleInput.error(error ? D.Lang.get('profile.team.create.errors.' + errors.teamTitle) : null);
			}

			if (m.inviteEmails !== null) {
				for (let i in this._emailInputs) {
					if (this._emailInputs.hasOwnProperty(i)) {
						let input = this._emailInputs[i];
						let error = errors && errors.inviteEmails && errors.inviteEmails[i];
						input.error(error ? D.Lang.get('profile.team.invite.error') : null);
					}
				}
			}

			if (m.paymentInfo !== null) {
				const type = m.paymentInfo.type;
				for (var field in this._fields[type]) {
					if (this._fields[type].hasOwnProperty(field)) {
						let error = errors && errors.paymentInfo && errors.paymentInfo[field] ? errors.paymentInfo[field] : null;
						this._fields[type][field].error(error ? D.Lang.get('profile.team.purchase.errors.' + field + '.' + error) : null);
					}
				}
			}
		},

		_onBraintree: function () {
			this._mGetBraintreeToken = new DR.services.GetBraintreeClientToken();
			this._mGetBraintreeToken.onLoad = this._onBraintreeToken;
			this._mGetBraintreeToken.onError = this._onBraintreeTokenError;
			this._mGetBraintreeToken.call({eventId: this.event.id});
			this.track();
		},

		track() {
			let count = 1;
			if( this._teamUsersCount ) {
				count = this._teamUsersCount.value();
			}
			let price = this._discountedPrice / 100;
			D.Analytics.klaviyo('Started Checkout', {
				"$event_id": this._paymentId + "_" + (new Date().getTime() / 1000),
				"$value": price,
				"Items": [{
					"ExperienceID": this.event.id,
					"ExperienceName": this.event.title,
					"Description": this.event.description,
					"Quantity": count,
					"ItemPrice": this.event.ticket.affiliatePrice / 100,
					"RowTotal": this.event.ticket.affiliatePrice / 100 * count,
					"URL": D.URL + D.url('/event/' + this.event.seoTitle).substr(1)
				}]
			})
			D.Analytics.branch(
				'INITIATE_PURCHASE', {
					"user_id": D.ID || 0,
					"event_id": this.event.id,
					"currency": "EUR",
					"revenue": price,
					"description": "Checkout"
				},
				[
					{
						"$content_schema": "COMMERCE_PRODUCT",
						"$canonical_identifier": D.url('/event/' + this.event.seoTitle).substr(1),
						"$price": this.event.ticket.affiliatePrice / 10,
						"$quantity": count,
						"$product_name": this.event.title
					}
				]);
			D.Analytics.fbq('InitiateCheckout', {
				content_type: 'product',
				contents: [{
					id: this.event.id,
					quantity: count
				}],
				num_items: 1,
				currency: 'EUR',
				value: price
			});
		},

		trackSuccess: function () {
			let count = 1;
			if( this._teamUsersCount ) {
				count = this._teamUsersCount.value();
			}
			let price = this._discountedPrice / 100;
			D.Analytics.ga({
				hitType: 'event',
				eventCategory: 'Ticket',
				eventAction: 'Purchased',
				eventLabel: this.event.title,
				eventValue: price
			});
			D.Analytics.fbq('Purchase', {
				content_type: 'product',
				contents: [{
					id: this.event.id,
					quantity: count
				}],
				num_items: 1,
				currency: 'EUR',
				value: price
			});
			D.Analytics.branch(
				"PURCHASE",
				{
					"user_id": D.ID || 0,
					"event_id": this.event.id,
					"currency": "EUR",
					"revenue": price,
					"description": "Checkout"
				},
				[
					{
						"$content_schema": "COMMERCE_PRODUCT",
						"$canonical_identifier": D.url('/event/' + this.event.seoTitle).substr(1),
						"$price": this.event.ticket.affiliatePrice / 10,
						"$quantity": count,
						"$product_name": this.event.title
					}
				]
			);
		},

		_onBraintreeToken: function () {
			this._braintreeToken = this._mGetBraintreeToken.re.token;
			this._createBraintree();
		},

		_onBraintreeTokenError: function () {

		},

		_createBraintree: function () {
			D.removeLoadingOverlay(this.node);
			this._braintreePopup = new T.Popup({
				className: 'popup-payment',
				overlayClick: false
			});
			let multiple = this._teamCount.value() > 1;
			this._braintreeContainer = mkE({
				tag: 'div',
				els: [
					{
						tag: 'div',
						id: 'braintree-container'
					},
					this._braintreeButton = mkE({
						tag: 'button',
						className: 'button button-pink button-block button-disabled',
						text: D.Lang.get(multiple ? 'gift-card.purchase' : 'profile.team.purchase.buy'),
						style: {
							marginTop: '12px'
						}
					})
				]
			});
			this._braintreePopup.setContent(this._braintreeContainer);
			let braintreeParams = {
				authorization: this._braintreeToken,
				container: '#braintree-container',
				card: {
					cardholderName: true
				},
				translations: D.LANG === 'lv' ? D.Lang.getBraintree() : null,
				vaultManager: true
			};
			if (D.BRAINTREE_3DS_ENABLED) {
				braintreeParams.threeDSecure = true;
			}
			braintree.dropin.create(braintreeParams, this._onBraintreeCreate);
			this._braintreePopup.open();
		},

		_onBraintreeCreate: function (createErr, instance) {
			this._braintreeInstance = instance;
			this._braintreeButton.addEventListener('click', this._onBraintreeMethodSelect);
			removeClassName(this._braintreeButton, 'button-disabled');
		},

		_onBraintreeMethodSelect: function () {
			if (this._errorNode) {
				this._errorNode.remove();
				delete this._errorNode;
			}
			let params = {};
			if (D.BRAINTREE_3DS_ENABLED) {
				params.threeDSecure = {
					amount: (this._discountedPrice / 100).toFixed(2),
					email: this.user.email
				};
			}
			this._braintreeInstance.requestPaymentMethod(params, this._onBraintreeMethodData);
		},

		_onBraintreeMethodData: function (requestPaymentMethodErr, payload) {
			if (requestPaymentMethodErr) {
				console.log(requestPaymentMethodErr);
				/*this._errorNode = T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled'));
				D.insertBefore(this._errorNode, this._braintreeContainer);*/
			} else if (payload.nonce) {
				D.loadingOverlay(this.node);
				this._mProcessBraintree = new DR.services.ProcessBraintreeTransaction();
				this._mProcessBraintree.nonce = payload.nonce;
				this._mProcessBraintree.paymentId = this._paymentId;
				this._mProcessBraintree.onLoad = this._onBraintreeSuccess;
				this._mProcessBraintree.onError = this._onBraintreeError;
				this._mProcessBraintree.call({eventId: this.event.id});
				this._braintreePopup.close();
			}
		},

		_onBraintreeSuccess: function () {
			let re = this._mProcessBraintree.re;
			if (re.ok) {
				this.trackSuccess();
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle + '/success?id=' + this._paymentId));
			} else {
				D.removeLoadingOverlay(this.node);
				let text = D.Lang.get('profile.team.purchase.errors.cancelled');
				if (re.errors.length) {
					text = re.errors[0];
				}
				this._errorNode = T.fatal(text).append(this._errorHolder);
				window.scroll(0,0);
			}
		},

		_onBraintreeError: function () {
			D.removeLoadingOverlay(this.node);
			this._errorNode = T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled')).append(this._errorHolder);
			window.scroll(0,0);
		}
	},
	mkE.Base
);
